module.exports = __webpack_public_path__ + "img/icon_left_5.79427ff3.png";